import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserWithRole } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly httpClient = inject(HttpClient);

  public fetchMe(): Observable<UserWithRole> {
    return this.httpClient.get<UserWithRole>(`${environment.baseApiUrl}/api/users/me`);
  }
}
